import JobApplyForm from "../../components/JobApplyForm/JobApplyForm";
import Title from "../../shared/ui/Title/Title";
import ParagraphSection from "../../shared/ui/ParagraphSection/ParagraphSection";
import cls from "./Career.module.css";
import MarginBottomContainer from "../../shared/ui/MarginBottomContainer/MarginBottomContainer";
import LineHeader from "../../shared/ui/LineHeader/LineHeader";


const Career = () => {
    return (
        <div id="career" className={cls.careerSection}>
            <div className="container container--main">
                <div className={cls.careerWrapper}>
                    <MarginBottomContainer margin={22}>
                        <LineHeader />
                        <Title title="Jobs at Socials" />
                    </MarginBottomContainer>

                    <MarginBottomContainer margin={63}>
                        <ParagraphSection>
                            <span className={cls.fs26}>
                                Be with us and give joy to millions of people!
                            </span>
                        </ParagraphSection>
                    </MarginBottomContainer>

                    <JobApplyForm />
                </div>
            </div>
        </div>
    );
};

export default Career;
